import React from "react";
import styles from "./Footer.module.css";
import iconInstagram from "../../Assets/icon-instagram.png";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        
        <div className={styles.brand}>
          <h2>Fohattech</h2>
          <p>
            Ferramentas web simples, rápidas e gratuitas para desenvolvedores e criadores.
          </p>
        </div>

        <div className={styles.links}>
          <h3>Links</h3>
          <a href="/">Home</a>
          <a href="/ferramentas">Ferramentas</a>
          <a href="/sobre">Sobre</a>
          <a href="/contato">Contato</a>
        </div>

        <div className={styles.legal}>
          <h3>Legal</h3>
          <a href="/politica-de-privacidade">Política de Privacidade</a>
          <a href="/termos-de-uso">Termos de Uso</a>
        </div>

        <div className={styles.social}>
          <h3>Redes</h3>
          <a href="https://www.instagram.com/fohattech/" target="_blank" rel="noreferrer">
            <img
              className={styles.iconInstagram}
              src={iconInstagram}
              alt="Instagram Fohattech"
            />
          </a>
        </div>

      </div>

      <div className={styles.copy}>
        <p>© {new Date().getFullYear()} Fohattech. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;